"use client";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

const GoogleTagManagerNoScript = () => {
  if (process.env.NODE_ENV !== "production" || !GTM_ID) return null;

  return (
    <>
      {/* GTM NoScript */}
      <div
        dangerouslySetInnerHTML={{
          __html: `
            <noscript>
              <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
                      height="0" width="0" style="display:none;visibility:hidden"
                      title="Google Tag Manager"></iframe>
            </noscript>
          `,
        }}
      />
    </>
  );
};

export { GoogleTagManagerNoScript };
